import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Button,
  Typography,
  Grid,
  Box,
  Checkbox,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
} from '@mui/material';
import axios from "axios";
import LoadingComponent from '../../ComponentLoader/index.js';
import { getDecoratorDestinations, previewPurchaseOrderRoute, updateShippingDetails } from '../../../services/shipping';
import dayjs from 'dayjs';
import CustomTextField from '../../CustomTextField';
import TextArea from '../../TextArea';
import CustomDropdown from '../../../components/CustomDropdownWithPlus';
import CustomDatePicker from '../../CustomDatePicker';
import { getClientContacts } from '../../../services/customer'
import { getSingleShipping, getAllClientAccounts, getAllOurAccounts } from '../../../services/shipping'
import { fetchSuppliersList } from '../../../services/suppliers'
import { fetchAddressList } from '../../../services/address';
import { getCustomerDetails } from '../../../services/customer';
import { fetchLatestCompletedSalesOrderForOrder } from '../../../services/estimation.js';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { shipToOptions, shippingAccountOptions, shippingMethodOptions, decoratorShipToOptions } from './index.controller.js'
import MainShippingForm from './MainShippingForm.js'
import DecoratorShippingForm from './DecoratorShippingForm.js'
import OtherSupplierForm from './OtherSupplierForm.js'
import ThirdPartyShippingAccount from '../ThirdPartyShippingAccount/index.js';
import ExpectedPoOutput from './ExpectedPoOutput.js';
import { buildShippingPayload } from './shippingFormPayload.js';
import { AuthContext } from '../../../helpers/AuthContext';
import {
  changeDecoratorDestination, configuredDecoratorAddressOption, decoratorAddressLockedForRole,
  decoratorDestinationError, decoratorShippingChoices, findDecoratorDestination,
  initialDecoratorAddress, decoratorOnwardRouteError, resolveShippingPublicOrderId,
} from './decoratorDestinationRules';

// Extract 'YYYY-MM-DD' from most date-ish inputs
 const ymdFromAnything = (v) => {
     if (!v) return null;
     const s = String(v).trim();
     // fast path: starts with YYYY-MM-DD (works for "2025-11-10", "2025-11-10T...", "2025-11-10 00:00:00")
     const m = s.match(/^(\d{4}-\d{2}-\d{2})/);
     if (m) return m[1];
     // fallback: find anywhere
     const m2 = s.match(/(\d{4}-\d{2}-\d{2})/);
     return m2 ? m2[1] : null;
   };

const toDayjsOrNull = (v) => {
  const ymd = ymdFromAnything(v);
  return ymd ? dayjs(ymd) : null;
};

const normalizeText = (value) => String(value || '').trim().toLowerCase();
const hasAddressSelection = (value) => {
  if (value === null || value === undefined) return false;
  const raw = String(value).trim();
  return raw !== '' && raw !== '0';
};

const ShippingModal = ({
  open,
  onClose,
  product,
  setOpen,
  selectedShippingDetailsId,
  order,
  onSaved, // <-- NEW (optional) rehydrate callback
  sourceShippingId,
  onSubmitPayload,
  title = 'Edit Shipping Details',
  helperText,
  submitLabel = 'Save',
}) => {
  const { instanceUniqueId, orderId: routeOrderId } = useParams();
  const { authState } = useContext(AuthContext) || {};
  const [formData, setFormData] = useState({
    supplier: '',
    supplierId: '',
    supplierSource: '',
    address: '',
    status: '',
    shipTo: '',
    shippingAccount: '',
    shippingQuote: '',
    shippingUser: '',
    manualShippingAccount: '',
    defaultMargin: '',
    shippingMethod: '',
    notes: '',
    inHandsDate: null,
    sampleOrder: false,
    firm: false,
    supplierNotes: '',
  });
  const [accountModal, setAccountModal] = useState({
    open: false,
    type: 'customer', // 'customer' | 'supplier'
  });

  const openAccountModal = (type) => {
    setAccountModal({ open: true, type });
  };
  
  const closeAccountModal = () => {
    setAccountModal((prev) => ({ ...prev, open: false }));
  };

  const { tabId, tabtype } = useParams();
  // This modal remains mounted when the project navigates to another tab.
  // Route tabId must only be interpreted as a shipping ID on Shipping routes.
  const activeShippingModalRef = useRef(false);
  const shippingFetchRequestRef = useRef(0);
  activeShippingModalRef.current = Boolean(open && (sourceShippingId || tabtype === 'shipping'));

  const [decoratorFormData, setDecoratorFormData] = useState({
    decorator: '',
    decoratorAddress: '',
    decoratorShipTo: '',
    clientAddress: '',
    companyAddress: '',
    inHandsDate: null,
    decoratorFirm: false,
    shippingAccount: '',
    shippingUser: '',
    manualShippingAccount: '',
    defaultMargin: '',
    shippingMethod: '',
    notes: '',
  });

  const [otherSupplierFormData, setOtherSupplierFormData] = useState({
    supplier: '',
    supplierAddress: ''
  })

  const [addressOptions, setAddressOptions] = useState([
    { id: 1, label: '123 Main St, NY', name: '123 Main St, New York, NY 10001' },
    { id: 2, label: '456 Maple Rd, CA', name: '456 Maple Road, Los Angeles, CA 90001' },
    { id: 3, label: '789 Oak Ln, TX', name: '789 Oak Lane, Dallas, TX 75201' }
  ]);
  const [loading, setLoading] = useState(false);
  const [apiLoading, setApiLoading] = useState(false)
  const [sampleOrder, setSampleOrder] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState('');
  const [selectedSupplierObj, setSelectedSupplierObj] = useState(null);
  const [legacySupplierNameFallback, setLegacySupplierNameFallback] = useState('');
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showDecoratorForm, setShowDecoratorForm] = useState(false);
  const [selectedShipTo, setSelectedShipTo] = useState('');
  const [decoratorOptions, setDecoratorsOptions] = useState([]);
  const [savedDecoratorId, setSavedDecoratorId] = useState(null);
  const [assignedEliteDecoratorId, setAssignedEliteDecoratorId] = useState(null);
  const [decoratorLookupError, setDecoratorLookupError] = useState('');
  const [customerDisplayName, setCustomerDisplayName] = useState("");

  const [supplierOptions, setSupplierOptions] = useState([
    { id: 1, name: "Elite Awards Department" },
    { id: 2, name: "AJJ Enterprise" },
    { id: 3, name: "AAA Marketing Group" }
  ]);
  const [clientAccounts, setClientAccounts] = useState([]);
  const [ourAccounts, setOurAccounts] = useState([]);
  const [supplierAccounts, setSupplierAccounts] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [customerAddressOptions, setCustomerAddressOptions] = useState([]);
  const [unresolvedSavedClientAddressId, setUnresolvedSavedClientAddressId] = useState(null);
  const [companyAddressOptions, setCompanyAddressOptions] = useState([]);
  const [instanceDisplayName, setInstanceDisplayName] = useState('');
  const [shipMethods, setShipMethods] = useState(shippingMethodOptions);
  const [resolvedCustomerId, setResolvedCustomerId] = useState(null);
  const [poRoutePreview, setPoRoutePreview] = useState(null);
  const [poRoutePreviewLoading, setPoRoutePreviewLoading] = useState(false);
  const savingRef = useRef(false);

  const selectedDecoratorDestination = useMemo(() => findDecoratorDestination(
    decoratorOptions, decoratorFormData.decorator
  ), [decoratorOptions, decoratorFormData.decorator]);
  const configuredDecoratorAddress = useMemo(() => configuredDecoratorAddressOption(
    selectedDecoratorDestination
  ), [selectedDecoratorDestination]);
  const decoratorReceivingAddressOptions = useMemo(() => (
    configuredDecoratorAddress ? [configuredDecoratorAddress, ...addresses] : addresses
  ), [addresses, configuredDecoratorAddress]);
  const visibleDecoratorOptions = useMemo(() => decoratorShippingChoices(
    decoratorOptions, decoratorFormData.decorator, savedDecoratorId
  ), [decoratorOptions, decoratorFormData.decorator, savedDecoratorId]);
  const decoratorAddressLocked = decoratorAddressLockedForRole(selectedDecoratorDestination, authState?.role);
  const decoratorAddressError = decoratorDestinationError({
    destination: selectedDecoratorDestination,
    addressId: decoratorFormData.decoratorAddress,
    locked: decoratorAddressLocked,
  });
  const handleDecoratorChange = (value) => {
    const nextId = value?.target?.value ?? value?.id ?? value ?? '';
    setDecoratorFormData((previous) => changeDecoratorDestination(previous, nextId, decoratorOptions));
  };
  const applyConfiguredDecoratorAddress = () => {
    if (!configuredDecoratorAddress || selectedDecoratorDestination?.rule?.visibleInShipping === false) return;
    setDecoratorFormData((previous) => ({ ...previous, decoratorAddress: configuredDecoratorAddress.id }));
  };

  const handleShipToChange = (option) => {
    setSelectedShipTo(option);
  };
  const handleRadio = (option, name) => {
    setFormData((prev) => ({
      ...prev, [name]: option,
      ...(name === 'shipTo' && option === 'elite' && companyAddressOptions.length
        ? { address: companyAddressOptions.find((a) => a.isDefault)?.id || companyAddressOptions[0].id }
        : {}),
    }))
  }

  // helper to build a readable one-liner for any address
  const buildDisplay = (a = {}) => {
    const line1 = a.street || a.streetAddress || "";
    const line2 = [a.city, a.state || a.stateProvince].filter(Boolean).join(", ");
    const parts = [
      a.addressName || a.label,
      line1,
      line2,
      a.postal || a.postalZipCode,
      a.country,
    ].filter(Boolean);
    return parts.join(" · ");
  };

  const fetchData = async (requestId) => {
    const isCurrentRequest = () => requestId === shippingFetchRequestRef.current && activeShippingModalRef.current;
    try {
      setApiLoading(true);
  
      // ─────────────────────────────────────────────────────────────
      // 0) Reference data
      // ─────────────────────────────────────────────────────────────
      const suppliers = await fetchSuppliersList();
      if (!isCurrentRequest()) return;
      // Gets all suppliers from EC
      setSupplierOptions(suppliers);
  
      const response = await getSingleShipping(sourceShippingId || tabId);
      if (!isCurrentRequest()) return;
      const shippingData = response?.data || {};
      const sr = shippingData?.shippingRecord || {};
      const linkedDecoratorId = sr?.assignedEliteDecorator?.decoratorId || null;
      // Only an untouched, addressless default client placeholder may be
      // proposed as a decorator leg. Existing saved shipping choices win.
      const suggestDecoratorRoute = Boolean(linkedDecoratorId && sr?.autoDecoratorRouteSuggested);
      setAssignedEliteDecoratorId(linkedDecoratorId);
      const linkedOrderId = resolveShippingPublicOrderId({ shippingRecord: sr, order, routeOrderId });
      const latestCompletedSO = linkedOrderId
        ? await fetchLatestCompletedSalesOrderForOrder(linkedOrderId)
        : null;
      if (!isCurrentRequest()) return;
  
      // Instance company address records have their own ID namespace.
      let loadedCompanyAddresses = [];
      if (instanceUniqueId) {
        try {
          const instanceRes = await axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`);
          if (!isCurrentRequest()) return;
          const instance = instanceRes?.data || {};
          setInstanceDisplayName(instance.instanceName || instance.companyName || 'Our Company');
          if (instance.id) {
            const companyRes = await axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instance.id}/shipping-company-addresses`, { headers: { accessToken: localStorage.getItem('accessToken') } });
            if (!isCurrentRequest()) return;
            loadedCompanyAddresses = (companyRes.data?.addresses || []).map((a) => ({ id: `company-${a.id}`, name: a.label || a.companyName || 'Company address', street: a.addressLine1, city: a.city, state: a.stateProvince, postal: a.postalCode, country: a.country, isDefault: Boolean(a.isDefault) }));
            setCompanyAddressOptions(loadedCompanyAddresses);
          }
        } catch (error) {
          if (!isCurrentRequest()) return;
          console.warn('Unable to load company shipping addresses', error?.message || error);
          setCompanyAddressOptions([]);
        }
      }
      // 1) Address table rows (system addresses)
      let addressResponse = await fetchAddressList();
      if (!isCurrentRequest()) return;
      addressResponse = (addressResponse || []).map((address) => ({
        id: address.id,
        label: address.addressName || buildDisplay(address),
        name: address.addressName || buildDisplay(address),
        street: address.streetAddress,
        suite: address.suiteApt,
        city: address.city,
        state: address.stateProvince,
        postal: address.postalZipCode,
        country: address.country,
      }));
      const savedDecoratorAddress = sr?.decoratorDetails?.Address;
      const savedDecoratorAddressId = Number(sr?.decoratorDetails?.AddressId);
      if (savedDecoratorAddress && Number.isInteger(savedDecoratorAddressId) && savedDecoratorAddressId > 0 &&
          !addressResponse.some((address) => String(address.id) === String(savedDecoratorAddressId))) {
        addressResponse.push({
          id: savedDecoratorAddressId,
          name: savedDecoratorAddress.addressName || buildDisplay(savedDecoratorAddress),
          street: savedDecoratorAddress.streetAddress,
          suite: savedDecoratorAddress.suiteApt,
          city: savedDecoratorAddress.city,
          state: savedDecoratorAddress.stateProvince,
          postal: savedDecoratorAddress.postalZipCode,
          country: savedDecoratorAddress.country,
        });
      }
      addressResponse = addressResponse.map((address) =>
        String(address.id) === String(savedDecoratorAddressId)
          ? { ...address, recipientName: sr?.decoratorDetails?.DecoratorName || address.name }
          : address
      );
  
      // ─────────────────────────────────────────────────────────────
      // 2) Attached customer's addresses — prefer order.attachedCustomers
      // ─────────────────────────────────────────────────────────────
      const fromOrder =
        Array.isArray(order?.attachedCustomers)
          ? order.attachedCustomers.find(v => v !== null && v !== undefined && String(v) !== '')
          : null;
  
      // Secondary places (kept as safe fallbacks)
      const fromSrOrder =
        Array.isArray(sr?.Order?.attachedCustomers)
          ? sr.Order.attachedCustomers.find(v => v !== null && v !== undefined && String(v) !== '')
          : (sr?.Order?.attachedCustomers ?? null);
  
      const fromShippingTop =
        Array.isArray(shippingData?.attachedCustomers)
          ? shippingData.attachedCustomers.find(v => v !== null && v !== undefined && String(v) !== '')
          : (shippingData?.attachedCustomers ?? null);
  
      const candidateCustomerIds = [
        fromOrder,                 // ← PRIMARY source (reliable)
        order?.CustomerId, order?.customerId,
        sr?.CustomerId, sr?.customerId,
        sr?.ClientId,   sr?.clientId,
        fromSrOrder,
        fromShippingTop,
      ].filter(v => v !== null && v !== undefined && String(v) !== '');
  
      const customerId = candidateCustomerIds[0] ?? null;
      setResolvedCustomerId(customerId);
  
      // Collect customer addresses or synthesize a raw client address
      let customerAddresses = [];
      if (customerId) {
        const custRes = await getCustomerDetails(customerId);
        if (!isCurrentRequest()) return;
        customerAddresses = (custRes?.customer?.address || []).map((a, idx) => {
          const id = Number.isInteger(a.id) ? a.id : `cust-${idx}`;
          return {
            id,
            label: a.addressName || a.label || buildDisplay(a),
            name:  a.addressName || a.label || buildDisplay(a),
            street:  a.street ?? a.streetAddress,
            city:    a.city,
            state:   a.state ?? a.stateProvince,
            postal:  a.postal ?? a.postalZipCode,
            country: a.country,
          };
        });
        setCustomerAddressOptions(customerAddresses);
        const cust = custRes?.customer || {};
        const name =
          cust.businessName ||
          cust.emailAddress ||
          cust.primaryEmail ||
          "";
        setCustomerDisplayName(name);
      } else {
        // No customerId? Seed a synthetic "client" address if present on decorator leg
        const raw = sr?.ShipTo?.ClientRawAddress;
        if (raw && (raw.street || raw.city || raw.state || raw.postal || raw.country)) {
          const synthetic = {
            id: 'cust-0',
            label: buildDisplay({
              addressName: raw.addressName,
              street: raw.street,
              city: raw.city,
              stateProvince: raw.state,
              postalZipCode: raw.postal,
              country: raw.country
            }),
            name: buildDisplay({
              addressName: raw.addressName,
              street: raw.street,
              city: raw.city,
              stateProvince: raw.state,
              postalZipCode: raw.postal,
              country: raw.country
            }),
            street: raw.street,
            city: raw.city,
            state: raw.state,
            postal: raw.postal,
            country: raw.country
          };
          customerAddresses = [synthetic];
          setCustomerAddressOptions(customerAddresses);
        }
      }
  
      // Merge customer addresses first (so they appear in their group)
      addressResponse = [
        ...customerAddresses,
        ...addressResponse,
      ];
  
      // Do not preselect a different customer's address while existing
      // decorator shipping is being hydrated from its saved canonical ID.
  
      setAddresses(addressResponse);
  
      // ─────────────────────────────────────────────────────────────
      // 3) Decorators + Accounts
      // ─────────────────────────────────────────────────────────────
      let options = [];
      try {
        if (!linkedOrderId || !instanceUniqueId) {
          throw new Error('Could not identify the order instance for decorator shipping rules.');
        }
        const decoratorResponse = await getDecoratorDestinations(linkedOrderId, instanceUniqueId);
        if (!isCurrentRequest()) return;
        if (!Array.isArray(decoratorResponse?.decorators)) {
          throw new Error('Could not load decorator shipping rules for this order.');
        }
        options = decoratorResponse.decorators.map((decorator) => ({
          ...decorator,
          id: String(decorator.id),
        }));
        setDecoratorLookupError('');
      } catch (error) {
        if (!isCurrentRequest()) return;
        // A settings lookup outage must not disable ordinary client/company
        // Shipping edits. Decorator saves remain blocked until rules can load.
        console.warn('Decorator shipping rules unavailable:', error?.message || error);
        setDecoratorLookupError(error?.response?.data?.message ||
          'Decorator shipping destinations could not be loaded. Reopen Shipping and retry before saving a decorator route.');
      }
      const savedId = sr?.decoratorDetails?.DecoratorId || null;
      // Keep a historic label readable even if the decorator is no longer in
      // the scoped list. It cannot be selected for a new shipping route.
      if (savedId && !findDecoratorDestination(options, savedId)) {
        options.push({
          id: String(savedId),
          name: sr.decoratorDetails.DecoratorName || 'Saved decorator',
          savedOnly: true,
          rule: { visibleInShipping: false },
        });
      }
      setSavedDecoratorId(savedId);
      setDecoratorsOptions(options);
      const initialDecoratorId = savedId ||
        (findDecoratorDestination(options, linkedDecoratorId)?.rule?.visibleInShipping !== false ? linkedDecoratorId : '') || '';
  
      let clientAccounts = await getAllClientAccounts({
        instanceUniqueId,
        customerId,
      });
      if (!isCurrentRequest()) return;
      clientAccounts = clientAccounts?.data?.map((account) => ({
        id: account.id,
        name: account.accountName,
        courier: account.courier || "",
      })) || [];
      setClientAccounts(clientAccounts);
  
      let oursAccounts = await getAllOurAccounts({ instanceUniqueId });
      if (!isCurrentRequest()) return;
      oursAccounts = oursAccounts?.data?.map((account) => ({
        id: account.id,
        name: account.accountName,
        courier: account.courier || "",
      })) || [];
      setOurAccounts(oursAccounts);

      if (instanceUniqueId) {
        const instanceRes = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`
        );
        if (!isCurrentRequest()) return;
        const instanceId = instanceRes?.data?.id;
        if (instanceId) {
          const shipMethodsRes = await axios.get(
            `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/ship-methods`,
            { headers: { accessToken: localStorage.getItem("accessToken") } }
          );
          if (!isCurrentRequest()) return;
          const methods = shipMethodsRes?.data?.methods || [];
          const mappedMethods = methods.map((method) => ({
            id: method.id,
            name: method.name,
            courier: method.courier || "",
          }));
          if (mappedMethods.length) {
            setShipMethods(mappedMethods);
            setFormData((prev) => ({
              ...prev,
              shippingMethod: prev.shippingMethod || mappedMethods[0].id,
            }));
          }
        }
      }
  
      // ─────────────────────────────────────────────────────────────
      // 4) Seed main form + decorator form from shipping record
      // ─────────────────────────────────────────────────────────────
      if (shippingData && sr) {
        const {
          IsSampleOrder,
          InhandsDate,
          IsFirm,
          SupplierNotes,
          ShippingMethod,
          ShippingAccount,
          SupplierId,
          SupplierName,
          SupplierSource,
          ShipToMethod,
          ShippingQuote,
          decoratorDetails,
        } = sr;
  
        // Helper to translate a stored numeric id back to the option id we have in memory
        const preferId = (id) => {
          if (id == null) return null;
          const match = customerAddresses.find(o => String(o.id) === String(id));
          return match ? match.id : null; // could be number or 'cust-#'
        };
  
        const savedDecoratorClientAddressId = decoratorDetails?.ShipTo === 'client'
          ? decoratorDetails?.ClientAddressId ?? null : null;
        const seedDecoratorClientAddr =
          preferId(savedDecoratorClientAddressId) ||
          (ShipToMethod === 'client' ? preferId(sr?.clientAddressId) : null) ||
          null;
        setUnresolvedSavedClientAddressId(
          savedDecoratorClientAddressId && !preferId(savedDecoratorClientAddressId)
            ? savedDecoratorClientAddressId : null
        );

        const soAddressText = latestCompletedSO?.shippingAddress || latestCompletedSO?.billingAddress || '';
        const soAddressMatch = customerAddresses.find((candidate) => (
          normalizeText(candidate?.name) === normalizeText(soAddressText) ||
          normalizeText(candidate?.label) === normalizeText(soAddressText) ||
          normalizeText(buildDisplay(candidate)) === normalizeText(soAddressText)
        ));
        const autoClientAddressId = soAddressMatch?.id ?? customerAddresses?.[0]?.id ?? '';

        const existingClientAddressId = (
          ShipToMethod === "elite"   && sr?.eliteSupplierAddress
            ? sr.eliteSupplierAddress.id
          : ShipToMethod === "client" && sr?.clientAddressId
            ? sr.clientAddressId
          : ShipToMethod === "supplier" && sr?.otherSupplierDetails
            ? sr.otherSupplierDetails.AddressId
          : ""
        );

        const shouldAutoSelectAddress =
          ShipToMethod === "client" &&
          !hasAddressSelection(existingClientAddressId);
  
        const hydratedSupplierSource =
          SupplierSource || (SupplierId ? "asi-supplier" : "");
        const isValidSupplierName = (value) => {
          const name = String(value || '').trim();
          return Boolean(name) && !/^unknown supplier$/i.test(name);
        };

        if (SupplierId && isValidSupplierName(SupplierName)) {
          setSelectedSupplierObj({
            id: SupplierId,
            Id: SupplierId,
            Name: SupplierName,
            name: SupplierName,
            supplierSource: hydratedSupplierSource,
            SupplierSource: hydratedSupplierSource,
            supplierKey: hydratedSupplierSource
              ? `${hydratedSupplierSource}:${SupplierId}`
              : String(SupplierId),
            hydratedFromShipping: true,
          });
        }

        const shippingAccountType = ShippingAccount?.Type || "";
        const manualShippingAccount = shippingAccountType === "other"
          ? String(
              ShippingAccount?.AccountValue ||
              ShippingAccount?.AccountType ||
              ShippingQuote ||
              ""
            ).trim()
          : "";

        setFormData((prev) => ({
          ...prev,
          supplier: SupplierId || "",
          supplierId: SupplierId || "",
          supplierSource: hydratedSupplierSource,
          sampleOrder: IsSampleOrder || false,
          firm: IsFirm || false,
          inHandsDate: toDayjsOrNull(InhandsDate),
          notes: SupplierNotes || "",
          shippingMethod: ShippingMethod || "",
          shipTo: suggestDecoratorRoute ? 'decorator' : ShipToMethod,
          shippingAccount: shippingAccountType,
          shippingQuote: ShippingQuote || "",
          shippingUser: shippingAccountType === "other" ? "" : ShippingAccount?.AccountValue || "",
          manualShippingAccount,
          supplierNotes: SupplierNotes || "",
          address: shouldAutoSelectAddress ? autoClientAddressId
            : (ShipToMethod === 'elite' && !hasAddressSelection(existingClientAddressId) && loadedCompanyAddresses.length
              ? loadedCompanyAddresses.find((a) => a.isDefault)?.id || loadedCompanyAddresses[0].id
              : existingClientAddressId),
        }));
  
        if (ShipToMethod === 'other_supplier' && sr?.otherSupplierDetails) {
          const details = sr.otherSupplierDetails;
          const matchingSupplier = (suppliers || []).find((option) => String(option.name || option.Name || '').toLowerCase() === String(details.SupplierName || '').toLowerCase());
          setOtherSupplierFormData({ supplier: matchingSupplier?.id || details.SupplierName || '', supplierAddress: details.AddressId || '' });
        }

        setDecoratorFormData((prev) => ({
          ...prev,
          decorator: initialDecoratorId,
          decoratorAddress: initialDecoratorAddress(
            findDecoratorDestination(options, initialDecoratorId),
            decoratorDetails?.AddressId,
            // A numeric legacy AddressId can exist with no deliverable
            // physical address. Repair only those incomplete saved routes
            // from the configured Matrix default; preserve complete overrides.
            {
              savedAddressComplete: !decoratorDetails?.AddressId ||
                ['streetAddress', 'city', 'stateProvince', 'postalZipCode', 'country']
                  .every((field) => String(decoratorDetails?.Address?.[field] ?? '').trim()),
            }
          ),
          decoratorShipTo: decoratorDetails?.ShipTo || "",
          clientAddress: seedDecoratorClientAddr ?? "",
          // ClientAddressId is the existing canonical onward Address ID. For
          // saved Elite routes, show that actual selected address on reopen,
          // not a new company default that might ship goods elsewhere.
          companyAddress: decoratorDetails?.ShipTo === 'elite'
            ? decoratorDetails?.ClientAddressId || "" : "",
          inHandsDate: toDayjsOrNull(decoratorDetails?.InhandsDate),
          decoratorFirm: !!decoratorDetails?.IsFirm,
          shippingAccount: decoratorDetails?.ShippingAccount || "",
          shippingUser: decoratorDetails?.ShippingAccount === "other"
            ? ""
            : decoratorDetails?.ShippingAccountId || "",
          manualShippingAccount: decoratorDetails?.ShippingAccount === "other"
            ? String(decoratorDetails?.DecoratorShippingAccountValue || "").trim()
            : "",
          shippingQuote: decoratorDetails?.ShippingAccountId || "",
          defaultMargin: decoratorDetails?.AddressId || "",
          shippingMethod: decoratorDetails?.ShippingMethod || "",
          notes: decoratorDetails?.DecoratorNotes || "",
        }));
        setLegacySupplierNameFallback(isValidSupplierName(SupplierName) ? SupplierName : '');

        if (!SupplierId && isValidSupplierName(SupplierName)) {
          try {
            const { data: supplierSearchRes } = await axios.get(
              `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/get-suppliers`,
              {
                params: {
                  instanceUniqueId,
                  q: SupplierName,
                  page: 1,
                  rpp: 50,
                  tab: 'all',
                },
                headers: { accessToken: localStorage.getItem('accessToken') },
              }
            );
            if (!isCurrentRequest()) return;
            const rows = supplierSearchRes?.rows || supplierSearchRes?.suppliers || supplierSearchRes?.Results || supplierSearchRes?.data || [];
            const normalizedRows = rows.map((r) => {
              const src = r?.Supplier || r || {};
              return {
                ...src,
                id: src.id ?? src.Id,
                Id: src.Id ?? src.id,
                Name: src.Name ?? src.name ?? src.SupplierName ?? src.businessName ?? '',
                supplierSource: 'core-supplier',
              };
            }).filter((r) => r?.id != null);
            const exactMatches = normalizedRows.filter((r) =>
              String(r?.Name || '').trim().toLowerCase() === String(SupplierName || '').trim().toLowerCase()
            );
            if (exactMatches.length === 1) {
              const match = exactMatches[0];
              setSelectedSupplierObj(match);
              setFormData((prev) => ({
                ...prev,
                supplier: match.id,
                supplierId: match.id,
                supplierSource: 'core-supplier',
              }));
            }
          } catch (err) {
            if (!isCurrentRequest()) return;
            console.warn('Legacy supplier-name hydration lookup failed:', err?.message || err);
          }
        }
      }
  
      setApiLoading(false);
    } catch (error) {
      // A navigation can complete while this request is in flight. Do not
      // redirect back to Shipping or show an error after leaving the modal.
      if (!isCurrentRequest()) return;
      setApiLoading(false);
      console.error("Failed to fetch order data:", error);
      toast.error(error?.response?.data?.message || error?.message || 'Could not load shipping details. Please try again.');
      onClose();
    }
  };
  
  

  const handleSelect = (e, name) => {
    if (name === "supplier") {
      const supplier = e?.supplier || null;
      const value = e?.target?.value ?? e?.id ?? "";
      const mode = e?.supplierSearchTab || e?.supplierSearchMode || "";
      const supplierSource =
        supplier?.supplierSource ||
        (mode === "all" ? "asi-supplier" : value ? "core-supplier" : "");
      setSelectedSupplierObj(supplier);
      setFormData((prev) => ({
        ...prev,
        supplier: value,
        supplierId: supplier?.id || supplier?.Id || value || "",
        supplierSource,
      }));
      return;
    }

    const value = e?.target?.value ?? e?.id ?? "";
    if (name === "shippingAccount") {
      setFormData((prev) => ({
        ...prev,
        shippingAccount: value,
        shippingUser: "",
        manualShippingAccount: value === "other" ? prev.manualShippingAccount || "" : "",
      }));
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  };

  const handleOtherSupplier = (e, name) => {
    setOtherSupplierFormData((prev) => ({
      ...prev,
      [name]: e?.target?.value
    }))
  }

  const handleDateChange = (newYmd, name) => {
       // newYmd should already be 'YYYY-MM-DD' from the picker layer
       setFormData((prev) => ({ ...prev, [name]: newYmd || null }));
  };

  const handleCheckBox = (name, value) => {
    setFormData((prev) => ({
      ...prev, [name]: !value
    }))
  }

  const handleInputChange = (event, name) => {
    const { value } = event.target
    setFormData((prev) => ({
      ...prev, [name]: value
    }));
  }

  const onSave = async () => {
    if (savingRef.current) return;
    try {
      if (formData.shipTo === 'decorator' && decoratorLookupError) {
        toast.error(decoratorLookupError);
        return;
      }
      const onwardRouteError = decoratorOnwardRouteError({
        shipToType: formData.shipTo,
        onward: decoratorFormData.decoratorShipTo,
        companyAddress: decoratorFormData.companyAddress,
      });
      if (onwardRouteError) {
        toast.error(onwardRouteError);
        return;
      }
      if (formData.shipTo === 'decorator' && decoratorAddressError) {
        toast.error(decoratorAddressError);
        return;
      }
      if (formData.shipTo === 'decorator' && decoratorFormData.decoratorShipTo === 'client') {
        const currentAddress = customerAddressOptions.find((address) =>
          String(address.id) === String(decoratorFormData.clientAddress)
        );
        if (!currentAddress || (unresolvedSavedClientAddressId &&
            String(currentAddress.id) === String(unresolvedSavedClientAddressId))) {
          toast.error('Choose a valid client delivery address before saving.');
          return;
        }
      }
      const manualShippingAccount = String(formData.manualShippingAccount || "").trim();
      const decoratorManualAccount = String(decoratorFormData.manualShippingAccount || "").trim();
      if (formData.shippingAccount === "other") {
        if (!manualShippingAccount) {
          toast.error("Enter the Other Shipping Account value.");
          return;
        }
        if (manualShippingAccount.length > 255) {
          toast.error("Other Shipping Account must be 255 characters or fewer.");
          return;
        }
      }
      if (formData.shipTo === "decorator" && decoratorFormData.shippingAccount === "other") {
        if (!decoratorManualAccount) {
          toast.error("Enter the decorator Other Shipping Account value.");
          return;
        }
        if (decoratorManualAccount.length > 255) {
          toast.error("Decorator Other Shipping Account must be 255 characters or fewer.");
          return;
        }
      }
      savingRef.current = true;
      setLoading(true);

      // figure out which address ID was selected
      const rawSelectedAddrId =
        formData.shipTo === "decorator"
          ? decoratorFormData.decoratorAddress
          : formData.shipTo === "other_supplier"
          ? otherSupplierFormData.supplierAddress
          : formData.address;

            // decorator → client destination
            const decClientId = decoratorFormData.clientAddress;
            const decClientOpt =
            customerAddressOptions.find(a => String(a.id) === String(decClientId)) ||
            addresses.find(a => String(a.id) === String(decClientId)) || {};
            const decClientIsRaw = typeof decClientOpt.id === 'string' && decClientOpt.id.startsWith('cust-');


      const selectedAddr =
        (formData.shipTo === 'decorator' ? decoratorReceivingAddressOptions : addresses)
          .find(a => String(a.id) === String(rawSelectedAddrId)) || {};

         const selectedAddrIsRaw =
           typeof selectedAddr.id === 'string' &&
           String(selectedAddr.id).startsWith('cust-');

      const resolveAccountName = () => {
        if (formData.shippingAccount === 'other') return manualShippingAccount;
        if (formData.shippingAccount === 'client') {
          return clientAccounts.find((a) => a.id === Number(formData.shippingUser))?.name || '';
        }
        if (formData.shippingAccount === 'our') {
          return ourAccounts.find((a) => a.id === Number(formData.shippingUser))?.name || '';
        }
        if (formData.shippingAccount === 'supplier') {
          return (
            supplierAccounts.find((a) => a.id === Number(formData.shippingUser))?.name ||
            formData.shippingQuote ||
            ''
          );
        }
        return '';
      };

      const resolveAccountValue = () => {
        if (formData.shippingAccount === 'other') return manualShippingAccount;
        if (formData.shippingAccount === 'supplier' && formData.shippingUser) {
          return formData.shippingUser;
        }
        if (formData.shippingAccount === 'our' || formData.shippingAccount === 'client') {
          return formData.shippingUser;
        }
        return formData.shippingQuote;
      };

      const selectedSupplierId = formData.supplierId ?? formData.supplier ?? null;
      const selectedSupplierOption = supplierOptions?.find((supplier) =>
        String(supplier?.id ?? supplier?.Id ?? '') === String(selectedSupplierId ?? '')
      );
      const selectedSupplierName =
        selectedSupplierObj?.Name ||
        selectedSupplierObj?.name ||
        selectedSupplierOption?.Name ||
        selectedSupplierOption?.name ||
        legacySupplierNameFallback ||
        '';
      const isValidSupplierName = (value) => Boolean(String(value || '').trim()) && !/^unknown supplier$/i.test(String(value).trim());
      if (selectedSupplierId && !isValidSupplierName(selectedSupplierName)) {
        toast.error('The selected supplier could not be resolved. Please reselect the supplier.');
        return;
      }

      const payload = buildShippingPayload({
        formData, decoratorFormData, otherSupplierFormData, selectedSupplierName, instanceUniqueId,
        selectedSupplierId, selectedSupplierObj, selectedSupplierOption, selectedAddr,
        selectedAddrIsRaw, decClientOpt, decClientIsRaw, decoratorOptions,
        decoratorManualAccount, resolveAccountName, resolveAccountValue, otherSupplierOptions: supplierOptions,
      });

      if (onSubmitPayload) {
        await onSubmitPayload(payload);
        return;
      }

      await updateShippingDetails(selectedShippingDetailsId, payload);

      toast.success('Shipping saved');

      // Close the modal first (snappier UX)
      onClose?.();

      // Rehydrate if possible; otherwise hard refresh
      if (typeof onSaved === 'function') {
        await Promise.resolve(onSaved());
      } else {
        setTimeout(() => window.location.reload(), 150);
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || 'Failed to save shipping');
    } finally {
      savingRef.current = false;
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open || !(sourceShippingId || (tabtype === 'shipping' && tabId))) return;
    const requestId = ++shippingFetchRequestRef.current;
    fetchData(requestId);
    return () => { shippingFetchRequestRef.current += 1; };
  }, [open, sourceShippingId, tabtype, tabId, instanceUniqueId]);

  useEffect(() => {
    const loadSupplierAccounts = async () => {
      if (!formData.supplier || !instanceUniqueId) {
        setSupplierAccounts([]);
        return;
      }
      try {
        let accounts = await getAllClientAccounts({
          instanceUniqueId,
          supplierId: formData.supplier,
        });


        //alert(JSON.stringify(accounts))

        accounts = accounts?.data?.map((account) => ({
          id: account.id,
          name: account.accountName,
          courier: account.courier || "",
        })) || [];
        setSupplierAccounts(accounts);
      } catch (error) {
        console.warn("Failed to load supplier accounts", error);
        setSupplierAccounts([]);
      }
    };

    loadSupplierAccounts();
  }, [formData.supplier, instanceUniqueId]);

  const getCourierForMethod = (methodId, methods = []) => {
    if (!methodId) return "";
    const match = methods.find((method) => String(method.id) === String(methodId));
    return match?.courier || "";
  };

  const filterAccountsByCourier = (accounts, courier) => {
    if (!courier) return accounts || [];
    return (accounts || []).filter((account) => {
      if (!account?.courier) return true;
      return String(account.courier).toLowerCase() === String(courier).toLowerCase();
    });
  };

  const mainCourier = getCourierForMethod(formData.shippingMethod, shipMethods);
  const decoratorCourier = getCourierForMethod(decoratorFormData.shippingMethod, shipMethods);

  //const filteredClientAccounts = filterAccountsByCourier(clientAccounts, mainCourier);
  //const filteredOurAccounts = filterAccountsByCourier(ourAccounts, mainCourier);
  //const filteredSupplierAccounts = filterAccountsByCourier(supplierAccounts, mainCourier);

  const filteredClientAccounts = clientAccounts
  const filteredOurAccounts = ourAccounts
  const filteredSupplierAccounts = supplierAccounts

  //const filteredDecoratorClientAccounts = filterAccountsByCourier(clientAccounts, decoratorCourier);
  //const filteredDecoratorOurAccounts = filterAccountsByCourier(ourAccounts, decoratorCourier);
  //const filteredDecoratorSupplierAccounts = filterAccountsByCourier(supplierAccounts, decoratorCourier);

  const filteredDecoratorClientAccounts = clientAccounts;
  const filteredDecoratorOurAccounts = ourAccounts;
  const filteredDecoratorSupplierAccounts =supplierAccounts;

  const supplierName = React.useMemo(() => {
    return (
      supplierOptions?.find((supplier) => String(supplier.id) === String(formData.supplier))
        ?.name || ""
    );
  }, [supplierOptions, formData.supplier]);

  useEffect(() => {
    if (!open || apiLoading || !tabId) return undefined;
    let active = true;
    const timer = setTimeout(async () => {
      setPoRoutePreviewLoading(true);
      try {
        // Preview uses stable destination identity; company contact IDs must not
        // masquerade as numeric Address IDs before the save transaction resolves them.
        const supplierShipToId = formData.shipTo === 'decorator'
          ? decoratorFormData.decoratorAddress
          : formData.shipTo === 'other_supplier'
            ? otherSupplierFormData.supplierAddress
            : formData.address;
        const companyOption = formData.shipTo === 'elite'
          ? companyAddressOptions.find((option) => String(option.id) === String(supplierShipToId))
          : null;
        const preview = await previewPurchaseOrderRoute(tabId, {
          supplierId: formData.supplierId || formData.supplier || null,
          supplierName,
          supplierShipToId: supplierShipToId || null,
          supplierShipToType: formData.shipTo || null,
          decoratorShipToType: formData.shipTo === 'decorator'
            ? decoratorFormData.decoratorShipTo || null
            : null,
          supplierShipToLabel: companyOption?.name ||
            (formData.shipTo === 'decorator' ? decoratorReceivingAddressOptions : addresses)
              .find((address) => String(address.id) === String(supplierShipToId))?.name || null,
          companyAddressId: companyOption ? Number(String(companyOption.id).slice(8)) : null,
          shippingMethod: formData.shippingMethod || null,
          shippingAccountId: formData.shippingUser || null,
          decoratorId: formData.shipTo === 'decorator' ? decoratorFormData.decorator || null : null,
          decoratorShipToId: formData.shipTo === 'decorator'
            ? decoratorFormData.decoratorShipTo === 'elite'
              ? decoratorFormData.companyAddress || null
              : decoratorFormData.decoratorShipTo === 'client'
                ? decoratorFormData.clientAddress || null
                : null
            : null,
        });
        if (active) setPoRoutePreview(preview);
      } catch (error) {
        console.warn('Expected PO route preview unavailable:', error?.message || error);
        if (active) setPoRoutePreview(null);
      } finally {
        if (active) setPoRoutePreviewLoading(false);
      }
    }, 250);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [
    apiLoading,
    addresses,
    decoratorReceivingAddressOptions,
    companyAddressOptions,
    decoratorFormData.clientAddress,
    decoratorFormData.companyAddress,
    decoratorFormData.decorator,
    decoratorFormData.decoratorAddress,
    decoratorFormData.decoratorShipTo,
    formData.address,
    formData.shipTo,
    formData.shippingMethod,
    formData.shippingUser,
    formData.supplier,
    formData.supplierId,
    open,
    otherSupplierFormData.supplierAddress,
    supplierName,
    tabId,
  ]);

  return (
    <React.Fragment>
      {apiLoading ? (
        <LoadingComponent/>
      ) : (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
          <DialogTitle className="create-order-dialog-title">{title}</DialogTitle>
          <DialogContent className="create-order-dialog-content">
            {helperText && <Typography color="text.secondary" sx={{ mb: 2 }}>{helperText}</Typography>}
            {decoratorLookupError && formData.shipTo === 'decorator' && (
              <Alert severity="warning" sx={{ mb: 2 }}>{decoratorLookupError}</Alert>
            )}
            {assignedEliteDecoratorId && (
              <Box sx={{ mb: 2, p: 1.5, bgcolor: 'action.hover', border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
                <Typography variant="body2" fontWeight={700}>
                  Sales Order decoration: {decoratorOptions.find((option) =>
                    String(option.id) === String(assignedEliteDecoratorId)
                  )?.name || 'Elite Decoration'}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {formData.shipTo === 'decorator'
                    ? String(decoratorFormData.decorator || '') === String(assignedEliteDecoratorId)
                      ? 'The Sales Order decorator is selected. Choose the decorator address and onward delivery destination to complete the shipping route.'
                      : 'The shipping route selects a different decorator from the Sales Order. Review the decorator selection before saving.'
                    : 'This product is assigned to Elite Decoration, but shipping currently goes elsewhere. Select Decorator under Ship To if goods must be routed for decoration.'}
                </Typography>
              </Box>
            )}
            <Grid container gap={5}>

              {/*PLEASE FIX, THIS DATA IS NOT BEING SEEDED :(
              <pre>
                Supplier options: 
                {JSON.stringify(filteredSupplierAccounts)}

                Our accounts: 
                {JSON.stringify(filteredOurAccounts)}

                Client accounts: 
                {JSON.stringify(filteredClientAccounts)}

              </pre>*/}


              <MainShippingForm
                formData={formData}
                selectedSupplierObj={selectedSupplierObj}
                handleSelect={handleSelect}
                handleCheckBox={handleCheckBox}
                handleDateChange={handleDateChange}
                handleInputChange={handleInputChange}
                handleRadio={handleRadio}
                supplierOptions={supplierOptions}
                setSupplierAccounts={setSupplierAccounts} 
                shippingAccountOptions={shippingAccountOptions}
                shippingMethodOptions={shipMethods}
                shipToOptions={shipToOptions.map((item) => item.id === 'elite' ? { ...item, name: instanceDisplayName || item.name } : item)}
                clientAccount={filteredClientAccounts}
                setClientAccounts={setClientAccounts}
                addressOptions={addresses}
                companyAddressOptions={companyAddressOptions}
                ourAccounts={filteredOurAccounts}
                supplierAccounts={filteredSupplierAccounts}

                accountModalOpen={accountModal.open}
                openAccountModal={openAccountModal}
                closeAccountModal={closeAccountModal}

                customerId={resolvedCustomerId}
                customerDisplayName={customerDisplayName}
                instanceUniqueId={instanceUniqueId}
              />

              {formData.shipTo === 'decorator' && unresolvedSavedClientAddressId &&
                decoratorFormData.decoratorShipTo === 'client' && (
                  <Typography color="error" role="alert" sx={{ width: '100%' }}>
                    Saved client address #{unresolvedSavedClientAddressId} could not be matched.
                    Select the intended client address and save to repair this route.
                  </Typography>
              )}
              {formData.shipTo === 'decorator' && (
                <DecoratorShippingForm
                  dayjs={dayjs}
                  decoratorFormData={decoratorFormData}
                  setDecoratorFormData={setDecoratorFormData}
                  decoratorShipToOptions={decoratorShipToOptions}
                  decoratorAddress={decoratorReceivingAddressOptions}
                  onDecoratorChange={handleDecoratorChange}
                  receivingAddressLocked={decoratorAddressLocked}
                  receivingAddressError={decoratorAddressError}
                  configuredAddress={configuredDecoratorAddress}
                  selectedDestination={selectedDecoratorDestination}
                  onApplyConfiguredAddress={applyConfiguredDecoratorAddress}
                  selectedShipTo={selectedShipTo}
                  handleShipToChange={handleShipToChange}
                  shippingAccountOptions={shippingAccountOptions}
                  shippingMethodOptions={shipMethods}
                  supplierOptions={supplierOptions}
                  decoratorOptions={visibleDecoratorOptions}
                  setClientAccounts={setClientAccounts}
                  setSupplierAccounts={setSupplierAccounts} 
                  ourAccounts={filteredDecoratorOurAccounts}
                  clientAccount={filteredDecoratorClientAccounts}
                  supplierAccounts={filteredDecoratorSupplierAccounts}
                  accountModalOpen={accountModal.open}
                  openAccountModal={openAccountModal}
                  closeAccountModal={closeAccountModal}                  
                  customerAddressOptions={customerAddressOptions}
                  companyAddressOptions={[
                    ...companyAddressOptions,
                    // The stored onward address may outlive the company-contact
                    // record. Keep its canonical address selectable for a no-op
                    // re-save; the API only allows reusing the exact saved ID.
                    ...addresses.filter((address) =>
                      decoratorFormData.decoratorShipTo === 'elite' &&
                      String(address.id) === String(decoratorFormData.companyAddress) &&
                      !companyAddressOptions.some((a) => String(a.id) === String(address.id))
                    ),
                  ]}
                  instanceDisplayName={instanceDisplayName || 'Our Company'}
                  customerId={resolvedCustomerId}
                  supplierId={formData.supplier || null}
                  supplierName={supplierName}
                  customerDisplayName={customerDisplayName}
                  instanceUniqueId={instanceUniqueId}
                />
              )}

              {formData.shipTo === 'other_supplier' && (
                <OtherSupplierForm
                  formData={otherSupplierFormData}
                  clientAccount={clientAccounts}
                  selectedSupplier={selectedSupplier}
                  supplierOptions={supplierOptions}
                  addressOptions={addresses}
                  setSupplierOptions={setSupplierOptions}
                  handleSelect={handleOtherSupplier}
                />
              )}

              <ThirdPartyShippingAccount
                open={accountModal.open}
                onClose={closeAccountModal}
                setClientAccounts={setClientAccounts}
                setAccounts={accountModal.type === 'supplier' ? setSupplierAccounts : setClientAccounts}
                instanceUniqueId={instanceUniqueId}
                customerId={accountModal.type === 'customer' ? resolvedCustomerId : null}
                supplierId={accountModal.type === 'supplier' ? (formData.supplier || null) : null}
                contextType={accountModal.type}
                contextLabel={accountModal.type === 'supplier' ? 'this supplier' : 'this customer'}
                contextName={accountModal.type === 'supplier' ? supplierName : customerDisplayName}
              />

            </Grid>
            <ExpectedPoOutput preview={poRoutePreview} loading={poRoutePreviewLoading} />
          </DialogContent>

          <DialogActions className="edit-product-dialog-action-bar">
            <Button onClick={onClose} color="secondary">Cancel</Button>
            <Button
              sx={{ backgroundColor: '#c0181f !important', color: 'white !important', ml: '5px !important' }}
              variant="contained"
              onClick={onSave}
              disabled={loading}
            >
              {loading ? 'Submitting' : submitLabel}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </React.Fragment>
  );
};

export default ShippingModal;
